import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import { UrlUtil } from "../../util/UrlUtil";

interface ISpecialtyListItem {
  element: HTMLAnchorElement;
  text: string;
  url: string | null;
  value: string | null;
}

export class HomeSpecialtySelect extends Component {

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);
  }

  public async init(): Promise<void> {
    const profile = await WyanokeUtil.loadUserProfile(true, false);

    if(document.referrer.indexOf(window.location.hostname) !== -1 ||
      new URLSearchParams(window.location.search).get("showall") === "1") {
      return;
    }

    if (profile) {
      const hasSpecialty =
        profile.isLoggedIn === "True" &&
        profile.contentspecialty;
      const queryStringMap = UrlUtil.getQueryString();

      if (hasSpecialty && queryStringMap.get("userspecialty") === undefined) {
        const specialty = (profile.contentspecialty || "").toLowerCase();
        const items = this.specialties;
        const item = items.find(s => s.text.toLowerCase() === specialty);
        if (item && item.element) {
          console.log("Redirecting to Users Specialty Page: "
            + item.element.href);
          window.location.href = item.element.href;
        }
      }
    }
  }


  private get specialties(): ReadonlyArray<ISpecialtyListItem> {
    const selector = ".dropdown-item";
    const items = this._element.querySelectorAll<HTMLAnchorElement>(selector);
    const specialtyElements = Array.from(items);

    return specialtyElements
      .map(element => {
        const text = (element.textContent || "").trim();
        const url = element.dataset.urlPattern || null;
        const value = element.dataset.value || null;

        return {
          element,
          text,
          url: url ? url.toLowerCase() : null,
          value
        };
      });
  }
}

ComponentFactory.registerComponent("HomeSpecialtySelect", HomeSpecialtySelect);
